import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f62988f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex":"1","justify-content":"flex-end","padding":"10px 20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("자동 갱신")
const _hoisted_3 = { style: {"width":"40px","text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_VideoModal = _resolveComponent("VideoModal")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_checkbox, { onClick: _ctx.onClickReload }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.time) + " 초", 1),
      _createVNode(_component_SyncOutlined, {
        spin: _ctx.isLoading,
        style: {"margin-left":"10px","color":"#096dd9","font-size":"20px"},
        onClick: _ctx.onClickRefresh
      }, null, 8, ["spin", "onClick"])
    ]),
    _createVNode(_component_a_table, {
      "row-key": "token",
      pagination: {
        total: _ctx.total,
        showTotal: (total) => `Total ${total} items`,
        current: _ctx.current,
        showSizeChanger: false,
        onChange: _ctx.onChangePagination,
      },
      "data-source": _ctx.apiData,
      loading: _ctx.isLoading,
      columns: _ctx.mergedColumns,
      sticky: "",
      class: "ant-table-striped"
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'facePartUrl')
          ? _renderSlot(_ctx.$slots, "default", {
              key: 0,
              record: record
            }, () => [
              (_ctx.isImageFormat(record.facePartUrl))
                ? (_openBlock(), _createBlock(_component_a_image, {
                    key: 0,
                    src: record.facePartUrl,
                    style: {"border-radius":"10px","max-height":"200px"}
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(_component_VideoModal, {
                    key: 1,
                    src: record.facePartUrl
                  }, null, 8, ["src"]))
            ], true)
          : (column.key === 'mediaUrl')
            ? _renderSlot(_ctx.$slots, "default", {
                key: 1,
                record: record
              }, () => [
                (_ctx.isImageFormat(record.mediaUrl))
                  ? (_openBlock(), _createBlock(_component_a_image, {
                      key: 0,
                      src: record.mediaUrl,
                      style: {"border-radius":"10px","max-height":"200px"}
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock(_component_VideoModal, {
                      key: 1,
                      src: record.mediaUrl,
                      controls: ""
                    }, null, 8, ["src"]))
              ], true)
            : (column.key === 'created')
              ? _renderSlot(_ctx.$slots, "default", {
                  key: 2,
                  record: record
                }, () => [
                  _createTextVNode(_toDisplayString(_ctx.getDate(record.created)), 1)
                ], true)
              : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["pagination", "data-source", "loading", "columns"])
  ]))
}